import { render, staticRenderFns } from "./Duel_Tutorial.vue?vue&type=template&id=55aa919c&"
import script from "./Duel_Tutorial.vue?vue&type=script&lang=js&"
export * from "./Duel_Tutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports